import { downloadFromBlob } from "../../../../../common/utils/download_utils";
import { IGetInspecaoObraImageUseCase } from "../../../presentation/useCases/read/get_inspecao_obra_image_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetInspecaoObraImageUseCase
 */

export class GetInspecaoObraImageUseCase implements IGetInspecaoObraImageUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getInspecaoObraImage(
    idInspecaoObra: number,
    imagePosition: number,
    imageName: string,
  ): Promise<void> {
    const response = await this.repository.getInspecaoObraImage(
      idInspecaoObra, imagePosition);
    await downloadFromBlob(response, imageName);
  }
}
